
export default function Terms() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-thin text-gray-900 mb-6">
            Terms of Service
          </h2>
          <div className="w-20 h-1 bg-teal-500 mx-auto mb-6"></div>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12 space-y-8">
          <div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h3>
            <p className="text-gray-600 leading-relaxed">
              By accessing and using LACOJEC LTDA's VPN service, you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to these terms, please do not use our service.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">2. Service Description</h3>
            <p className="text-gray-600 leading-relaxed">
              LACOJEC LTDA provides VPN services that allow users to establish secure, encrypted connections to the internet. Our service is designed to protect user privacy and enable secure browsing across various networks.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">3. Privacy and Data Protection</h3>
            <p className="text-gray-600 leading-relaxed">
              We maintain a strict zero-log policy. We do not track, collect, or store any information about your online activities. Your privacy is our top priority, and we use industry-standard encryption to protect your data.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">4. Acceptable Use</h3>
            <p className="text-gray-600 leading-relaxed">
              Users must comply with all applicable laws and regulations when using our VPN service. The service may not be used for any illegal activities, including but not limited to copyright infringement, hacking, or distribution of malicious software.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">5. Service Availability</h3>
            <p className="text-gray-600 leading-relaxed">
              While we strive to maintain continuous service availability, LACOJEC LTDA does not guarantee uninterrupted access to the VPN service. We reserve the right to modify, suspend, or discontinue the service at any time for maintenance or improvements.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">6. Limitation of Liability</h3>
            <p className="text-gray-600 leading-relaxed">
              LACOJEC LTDA shall not be liable for any indirect, incidental, special, or consequential damages arising from the use or inability to use our VPN service. Users assume all responsibility for their use of the service.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">7. Modifications to Terms</h3>
            <p className="text-gray-600 leading-relaxed">
              We reserve the right to modify these terms at any time. Users will be notified of significant changes, and continued use of the service constitutes acceptance of the modified terms.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">8. Contact Information</h3>
            <p className="text-gray-600 leading-relaxed">
              For questions or concerns regarding these terms, please contact us at contact@lacojecltda.com or call +1 7408727749.
            </p>
          </div>

          <div className="pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              Last updated: January 2025
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
